import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Navigation } from './Routes/Navigations';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ToastContainer />
        <Navigation />
      </BrowserRouter>
    </div>
  );
}

export default App;
